import ChipColors from './ChipColors';

export default [
  {
    text: 'Validado',
    value: 'VALIDADO',
    ...ChipColors.success,
  },
  {
    text: 'Em análise',
    value: 'EM_ANALISE',
    ...ChipColors.warning,
  },
  {
    text: 'Recusado',
    value: 'RECUSADO',
    ...ChipColors.danger,
  },
  {
    text: 'Sem validação',
    value: 'SEM_VALIDACAO',
    ...ChipColors.neutral,
  },
  {
    text: 'Pendente',
    value: 'PENDENTE',
    ...ChipColors.wait,
  },
  {
    text: 'Restrito',
    value: 'CADASTRO_RESTRITO',
    ...ChipColors.wait,
  },
];
